<template>
    <div>
        <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
            <h3 slot="header" class="mb-0 font-weight-500">Refinance</h3>
            <b-form @submit.prevent="submit">
                <b-row class="justify-content-center">
                    <b-col cols="12" md="6">
                        <b-form-group label="Latest Market Value">
                            <CurrencyInput
                                v-model="form.remortgage_amount"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group label="Latest Bank Outstanding">
                            <CurrencyInput
                                v-model="form.bank_outstanding"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-button block variant="primary" class="mb-5" type="submit">Submit</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </modal>
        <modal :show.sync=show_bank modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
            <h3 slot="header" class="mb-0 font-weight-500 text-center">Add Refinance Application</h3>
            <b-form role="form" @submit.prevent="addProductApplication">
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Bank">
                            <el-select v-model="form.bank_code" filterable placeholder="Select">
                                <el-option
                                v-for="bank in banks"
                                :key="bank.bank_code"
                                :label="bank.bank_name"
                                :value="bank.bank_code"
                                >
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="Loan Amount">
                            <b-form-input
                            v-model="form.loan_amount"
                            type="text"
                            step="0.01"
                            required
                            
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="Interest (%)">
                            <b-form-input
                            v-model="form.interest"
                            type="number"
                            step="0.01"
                            required
                            
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="Tenure Year">
                            <el-select v-model="form.tenure_years" placeholder="Select" >
                                <el-option
                                    v-for="num in 35"
                                    :key="num"
                                    :label="num + ' Years'"
                                    :value="num"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="Installment">
                            <b-form-input
                            v-model="form.installment"
                            type="number"
                            required
                            step="0.01"
                            
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="Bank Outstanding">
                            <b-form-input
                            v-model="form.bank_outstanding"
                            type="number"
                            required
                            step="0.01"
                            disabled
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="Cashout Amount">
                            <b-form-input
                            v-model="form.cashout_amount"
                            type="number"
                            required
                            step="0.01"
                            disabled
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" v-if="checkAppCode('sas')">
                            <h3 class="mb-4">Arrangement Fee</h3>
                        </b-col>

                    <b-col cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Arrangement Fee Amount">
                            <b-form-input
                            v-model="form.arrangement_fee"
                            type="number"
                            step="0.01"
                            required
                                ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Arrangement Fee SST">
                            <b-form-radio-group
                                v-model="form.arrangement_fee_sst"
                                :options="SST_OPTIONS"
                                required
                            
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" v-if="checkAppCode('sas')">
                            <b-form-group label="Total Arrangement Fee (RM)">
                            <b-form-input
                            v-model="form.arrangement_fee_amount"
                            type="text"
                            required
                            disabled
                            placeholder="0.00"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                        <b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_add">Add</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </modal>
    </div>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import {
  calculateInstallment, 
  calculateLoanAmount,
} from '@/assets/js/calculator.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import CurrencyInput from '@/components/CurrencyInput'
import {SST_OPTIONS} from '@/assets/js/options.js'

export default {
    props:{
        proposal: Object,
        show_refinancing_application: Boolean,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        CurrencyInput,
    },
    computed: {
        show: {
            get() {
                return this.show_refinancing_application;
            },
            set(newVal) {
                this.$emit('update:show_refinancing_application', newVal);
            },
        },
    },
    data() {
        return {
            is_loading_add: false,
            form:{
                bank_code: '',
                bank_name: '',
                interest: '',
                tenure_years: '',
                bank_status: '',
                loan_amount:'',
                installment:'',
                arrangement_fee: 0,
                arrangement_fee_any_amount: 0,
                arrangement_fee_amount: 0,
                arrangement_fee_sst: 0,
                bank_outstanding: 0,
                remortgage_amount: 0,
                cashout_amount: 0,
            },
            show_bank: false,
            banks:[],
            dsr_bank: null,
            SST_OPTIONS: SST_OPTIONS
        }
    },
    watch:{
        'form':{
            handler(newVal){
                if(newVal){
                    //set installment
                    this.form.installment = parseFloat(calculateInstallment(newVal.loan_amount, newVal.interest, newVal.tenure_years)).toFixed(2)

                    let sst_fee = parseFloat(this.form.arrangement_fee) * parseFloat(this.form.arrangement_fee_sst) / 100
                    //set total arragement fee
                    let arrangement_fee_amount = parseFloat(this.form.arrangement_fee) + parseFloat(sst_fee)
                    if(isNaN(arrangement_fee_amount)){
                        this.form.arrangement_fee_amount = 0
                    }else{
                        this.form.arrangement_fee_amount = arrangement_fee_amount
                    }

                    if(newVal.loan_amount)
                    {
                        this.form.cashout_amount = newVal.loan_amount - this.form.bank_outstanding;
                    }
                }
            },
            deep: true
        },
        'form.bank_code':{
            handler(newVal){
                this.setDSRBank()
            },
            immediate: true,
        },
    },
    methods: {
        resetForm(){
            this.form.bank_code = '',
            this.form.bank_name = '',
            this.form.interest = '',
            this.form.tenure_years = '',
            this.form.loan_margin = '',
            this.form.loan_amount ='',
            this.form.installment =0,
            this.form.arrangement_fee = 0,
            this.form.arrangement_fee_any_amount = 0,
            this.form.arrangement_fee_amount = 0,
            this.form.arrangement_fee_sst = 0,
            this.form.bank_outstanding = 0,
            this.form.remortgage_amount = 0,
            this.form.cashout_amount = 0,
            this.dsr_bank = null,
            this.banks = []
        },
        addProductApplication(){
            if(this.form.bank_code === ''){
                return
            }
            let data = {
                "pcom_psal_id": this.proposal.psal_id,
                "pcom_bank_id": null,
                "pcom_bank_name": this.dsr_bank.bank_name ?? null,
                "pcom_bank_code": this.form.bank_code,
                "pcom_loan_statue": "REFINANCE",
                "pcom_credit_limit": null,
                "pcom_final_installment":  this.form.installment,
                "pcom_card_expiry": null,
                "pcom_account_number": null,
                "pcom_remark": null,
                "pcom_product_detail":{
                    "pcp_product_type":"REFINANCE",
                    "pcp_loan_amount": this.form.loan_amount,
                    "pcp_spa_amount": null,
                    "pcp_max_eligible_amount": null,
                    "pcp_interest_rate": this.form.interest,
                    "pcp_margin_finance": this.form.loan_margin,
                    "pcp_monthly_installment": this.form.installment,
                    "pcp_tenure": this.form.tenure_years,
                    "pcp_rebate_rate":null,
                    "pcp_rebate_amount":null,
                    "pcp_arragement_fee_rate": this.form.arrangement_fee,
                    "pcp_arragement_fee_rate_sst": this.form.arrangement_fee_sst,
                    "pcp_arragement_fee_amount":this.form.arrangement_fee_amount,
                    "pcp_cash_back_amount":null,
                    "pcp_client_net_amount":null,
                    "pcp_project_id":null,
                    "pcp_unit_id":null,
                    "pcp_project_name": null,
                    "pcp_project_image_url":null,
                    "pcp_lease_type":null,
                    "pcp_project_type": null,
                    "pcp_project_unit_no": null,
                    "pcp_project_json":{
                        "prod_ref_remortgage_amount": this.form.remortgage_amount,
                        "prod_ref_bank_outstanding": this.form.bank_outstanding,
                        "prod_ref_cashout_amount": this.form.cashout_amount,
                    },
                }
            }

            axios.post(services.initial_proposal +'ccris-item', data, {headers:getHeader()})
                .then(res=>{
                    this.notifySuccess('<b>Proposal:</b> - Successfully Added Product.')
                    this.resetForm()
                    initialProposalEventBus.$emit('refresh-proposal-detail')
                    this.$emit('update:show_refinancing_application', false)
                })
                .catch(e=>{
                    this.errorFunction(e)
                })
        },
        setDSRBank(){
            this.dsr_bank = this.banks.find(bank => bank.bank_code == this.form.bank_code)
            if(this.dsr_bank ){
                this.form.interest = this.dsr_bank.bank_loan_interest_rate
                this.form.tenure_years = this.dsr_bank.bank_loan_tenure_year
                // refinance
                this.form.loan_amount = this.dsr_bank.bank_refinance_loan_amount
                this.form.loan_margin = this.dsr_bank.bank_refinance_loan_margin
                this.form.cashout_amount = this.dsr_bank.bank_refinance_cashout_amount

            }else{
                this.form.interest = ''
                this.form.tenure_years = ''
            }
        },
        getBanks(){
            axios.get(services.customer + 'customer/' + this.proposal.psal_customer_id +'/dsr.eligibilities?formula=RF&bank_outstanding='
            +this.form.bank_outstanding + '&remortgage_amount=' + this.form.remortgage_amount, {headers: getHeader()})
            .then(res=>{
                    this.banks = res.data.data.bank_eligibilities
                })
                .catch(e =>{
                    this.errorFunction(e)
                })
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        submit() {
            this.getBanks();
            this.show_bank = true;
        }
    }
}
</script>